var path = 'views/value/textarea.html';
var html = "<div class=form-group> <label for=fieldValue>Wert</label> <textarea type=text class=form-control id=fieldValue ng-model=models.elementCopy.value></textarea> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;